<template>
  <div class="row">
    <ValidationObserver
      ref="formObserver"
      tag="form"
      novalidate
      @submit.prevent="handleSubmit"
    >
      <div class="col-12">
        <div class="row">
          <div class="col-8">
            <Breadcrumb :page="page" />
          </div>
          <div class="col-4 mt-5 text-right ">
            <div class="col-12 mx-0">
              <router-link to="/student/AdditionalEvaluations">
                <ActionButton
                  variant="outline-success mr-2"
                  i="fas fa-arrow-circle-left"
                >
                  {{ field.btnReturn.text }}
                </ActionButton>
              </router-link>
              <ActionButton
                v-if="!isExistingReferral"
                :class="!field.btnSave.isEnabled ? 'disabled-page' : ''"
                :disabled="!field.btnSave.isEnabled"
                type="submit"
                variant="success mr-2"
                i="fas fa-save"
                @click="handleSubmit"
              >
                {{ field.btnSave.text }}
              </ActionButton>
              <ActionButton
                v-else-if="isPendingSignatureMode && activeTab === 1"
                type="button"
                class="mr-2"
                variant="success"
                i="fas fa-flag"
                :disabled="isSubmittingSignedReferral"
                @click="submitPendingSignatureReferral"
              >
                Someter
              </ActionButton>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="dropdown-divider pb-2 mx-4" />
        </div>
      </div>

      <div v-if="isPendingSignatureMode" class="row mx-3 mb-3">
        <div class="col-12">
          <WarningBox
            title="Para que esta solicitud se considere sometida, usted y el padre, madre o encargado del estudiante deben completar el proceso de firma y cargar el documento firmado en el sistema. Mientras este proceso no se complete, la solicitud permanecerá en estatus Pendiente de Firma y no se considerará un Referido Nuevo en el sistema."
          />
        </div>
      </div>

      <div
        v-if="isPendingSignatureMode"
        class="pending-signature-tabs mx-3 my-3"
      >
        <button
          type="button"
          :class="{ active: activeTab === 0 }"
          @click="activeTab = 0"
        >
          Referido a Evaluación
        </button>
        <button
          type="button"
          :class="{ active: activeTab === 1 }"
          @click="activeTab = 1"
        >
          Firma
        </button>
      </div>

      <div v-show="!isPendingSignatureMode || activeTab === 0">
        <div class="row mx-2">
          <div class="col-12">
            <div class="row">
              <div class="col-12">
                <SectionTitle content="Información General" />
              </div>
            </div>
            <div class="dropdown-divider w-100 my-0" />
            <div class="row mx-1 pt-1">
              <div class="col-2 pt-1">
                <ValidationProvider
                  v-slot="{ errors }"
                  mode="eager"
                  :rules="
                    field.datePickerDateEvaluation.isRequired ? 'required' : ''
                  "
                >
                  <CustomDatePicker
                    v-model="field.datePickerDateEvaluation.selected"
                    :disabled="field.datePickerDateEvaluation.disabled"
                    :label="field.datePickerDateEvaluation.label"
                    :error="errors[0]"
                    :custom-error-msg="field.datePickerDateEvaluation.errorMsg"
                    :max-date="field.datePickerDateEvaluation.maxDate"
                    class="custom-datetime-picker-container custom-datetime-picker-container-grey"
                  />
                </ValidationProvider>
              </div>
              <div class="col-2 pt-1" />
              <div class="col-3 pt-1">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="dropDownEvaluation"
                  mode="eager"
                  :rules="
                    `${field.dropDownEvaluation.isRequired ? 'required' : ''}`
                  "
                >
                  <CustomDropDown
                    :id="field.dropDownEvaluation.id"
                    v-model="field.dropDownEvaluation.selected"
                    :disabled="field.dropDownEvaluation.disabled"
                    :label="field.dropDownEvaluation.label"
                    :custom-error-msg="field.dropDownEvaluation.errorMsg"
                    :error="errors[0]"
                    :placeholder="field.dropDownEvaluation.placeHolder"
                    :fieldkey="field.dropDownEvaluation.fieldkey"
                    :fieldname="field.dropDownEvaluation.fieldname"
                    :options="field.dropDownEvaluation.items"
                    @input="getDisciplines"
                  />
                </ValidationProvider>
              </div>
              <div class="col-2 pt-1" />
              <div class="col-3 pt-1">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="dropDownDiscipline"
                  mode="eager"
                  :rules="
                    `${field.dropDownDiscipline.isRequired ? 'required' : ''}`
                  "
                >
                  <CustomDropDown
                    :id="field.dropDownDiscipline.id"
                    v-model="field.dropDownDiscipline.selected"
                    :disabled="field.dropDownDiscipline.disabled"
                    :label="field.dropDownDiscipline.label"
                    :custom-error-msg="field.dropDownDiscipline.errorMsg"
                    :error="errors[0]"
                    :placeholder="field.dropDownDiscipline.placeHolder"
                    :fieldkey="field.dropDownDiscipline.fieldkey"
                    :fieldname="field.dropDownDiscipline.fieldname"
                    :options="field.dropDownDiscipline.items"
                    @input="onChangeDiscipline"
                  />
                </ValidationProvider>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-12">
                <SectionTitle
                  content="Indique las necesidades académicas o funcionales que presenta el estudiante y cómo el especialista podría apoyar"
                />
              </div>
            </div>
            <div class="dropdown-divider w-100 mt-0 pb-1" />
            <div class="row mt-1">
              <div class="col-12">
                <ValidationProvider
                  v-slot="{ errors }"
                  mode="eager"
                  :rules="field.textAreaReason.isRequired ? 'required' : ''"
                >
                  <CustomTextArea
                    v-show="field.textAreaReason.isVisible"
                    v-model="field.textAreaReason.model"
                    :disabled="field.textAreaReason.disabled"
                    :maxlength="field.textAreaReason.maxlength"
                    :rows="field.textAreaReason.rows"
                    :placeholder="field.textAreaReason.placeHolder"
                    :error="errors[0]"
                    :custom-error-msg="field.textAreaReason.errorMsg"
                  />
                </ValidationProvider>
              </div>
            </div>

            <div class="row">
              <div class="col-12 px-1 pr-3">
                <WarningBox
                  title="Si desea hacer una evaluación Trianual, debe hacerse por la Pantalla Proceso de Evaluación Trianual o Cambio de Impedimento."
                />
              </div>
            </div>
          </div>

          <student-alternate-placement
            v-if="isEFASelected"
            ref="alternatePlacementRef"
            v-model="alternatePlacementInfo"
            class="mt-3"
            :readonly="field.alternatePlacement.disabled"
            :document-errors="documentErrors"
            :is-compu-minute-system-selection-enabled="
              isCompuMinuteSystemSelectionEnabled
            "
            :student-sie-id="studentSie"
            :minute-info="minuteInfo"
            :on-go-to-draft-minute="goToDraftMinute"
            @minute-info-input="minuteInfo = $event"
          />
        </div>
        <template v-if="isAdaptedPhysicalEducationSelected">
          <student-medical-info
            v-model="medicalInfo"
            class="	mt-3 mx-3"
            :readonly="field.medicalInformation.disabled"
          />
          <div class="mx-3 tag-badge pl-2 mb-3">
            <span class="dot color-orange">
              <i class="far fa-check-circle orange-icon-badge-align" />
            </span>
            <span class="tag-badge-title py-1 pl-2">
              Autorización de Evaluación
            </span>
          </div>
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-checkbox-single-option
              v-model="field.checkboxConditions.selected"
              :disabled="field.checkboxConditions.disabled"
              class="mx-3"
              title="Acepto y estoy consciente del proceso de evaluación que se va a ofrecer a mi hijo/a en epígrafe. Entiendo y comprendo que: a) tengo derecho de estar presente el día de la evaluación; b) la evaluación puede ser realizada en la escuela a la cual asiste mi hijo/a o puedo ser citado al Centro de Evaluación de EFA de la Oficina Regional Educativa (si cuentan con uno) u otras facilidades identificadas por el comité de evaluación de EFA; y c) cuando la evaluación se realice en la escuela donde asiste mi hijo/a, mi ausencia no afectará la administración de la evaluación. Además, todas mis dudas fueron aclaradas y entiendo todos los asuntos discutidos anteriormente."
              option-text="Acepto los términos y responsabilidades"
              :error="errors[0]"
              custom-error-msg="Favor aceptar los términos y responsabilidades al autorizar la evaluación."
            />
          </validation-provider>
        </template>
        <student-intervention-level
          v-if="isVocationalEducationSelected"
          ref="interventionLevelRef"
          v-model="interventionLevelInfo"
          class="	mt-3 mx-3"
          :readonly="field.interventionLevel.disabled"
          :additional-documents="additionalDocuments"
          :is-compu-minute-system-selection-enabled="
            isCompuMinuteSystemSelectionEnabled
          "
          :student-sie-id="studentSie"
          :minute-info="minuteInfo"
          :on-go-to-draft-minute="goToDraftMinute"
          @minute-info-input="minuteInfo = $event"
        />

        <ABADocumentation
          v-if="isABASelected"
          ref="abaDocumentationRef"
          v-model="abaDocuments"
          class="	mt-3 mx-3"
          :additional-documents="additionalDocuments"
          :is-compu-minute-system-selection-enabled="
            isCompuMinuteSystemSelectionEnabled
          "
          :student-sie-id="studentSie"
          :minute-info="minuteInfo"
          :on-go-to-draft-minute="goToDraftMinute"
          @minute-info-input="minuteInfo = $event"
        />

        <div
          v-if="
            selectedDisciplineId &&
              !isEFASelected &&
              !isABASelected &&
              !isVocationalEducationSelected
          "
          class="mt-3 mx-3"
        >
          <SectionTitle has-line content="Documentos" />
          <DocumentsForm
            ref="documentsFormRef"
            class="mt-3"
            :show-title="false"
            :documents="additionalDocuments"
            :allowed-document-types="additionalDocumentTypes"
            :multiple-uploads-document-type-ids="[]"
            :minute-document-type-id="documentTypes.SAEE_Minute"
            :is-compu-minute-system-selection-enabled="isCompuMinuteSystemSelectionEnabled"
            :student-sie-id="studentSie"
            :minute-info="minuteInfo"
            :on-go-to-draft-minute="goToDraftMinute"
            @minute-info-input="minuteInfo = $event"
          />
        </div>

        <DocumentsForm
          v-if="isExistingReferral"
          class="mt-3 mx-3"
          :documents="savedDocuments"
          :allowed-document-types="[]"
          :multiple-uploads-document-type-ids="[]"
          read-only
        />

        <div v-if="!isAdaptedPhysicalEducationSelected" class="row mx-2 mt-4">
          <div class="col-12">
            <div slot="header">
              <div class="tag-badge pl-2">
                <span class="dot text-center">
                  <i
                    class="far fa-check-circle orange-icon orange-icon-badge-align"
                  />
                </span>
                <span class="tag-badge-title py-1 pl-2">
                  Términos y Responsabilidades
                </span>
              </div>
            </div>
            <div class="row mx-1">
              <div class="col-12 px-0">
                <div class="border-box">
                  Certifico por este medio, que este referido podrá encontrarse
                  en el expediente físico del estudiante firmado por todas las
                  partes involucradas. (0502)
                </div>
              </div>
            </div>
            <ValidationProvider
              v-slot="{ errors }"
              mode="eager"
              name="checkboxConditions"
              :rules="field.checkboxConditions.isRequired ? 'required' : ''"
            >
              <div class="row mx-1">
                <div
                  class="border-box gray"
                  :class="{ error: errors.length > 0 }"
                >
                  <div class="col-12 px-0 py-0">
                    <div class="custom-control custom-checkbox">
                      <div class="custom-control custom-checkbox">
                        <input
                          id="checkboxConditions"
                          v-model="field.checkboxConditions.selected"
                          :disabled="field.checkboxConditions.disabled"
                          type="checkbox"
                          class="custom-control-input"
                          name="checkboxConditions"
                          @change="checkboxConditionsChange()"
                        />
                        <label
                          class="custom-control-label pl-3"
                          for="checkboxConditions"
                        >
                          Acepto los términos y responsabilidades
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="errors.length > 0" class="row mt-1">
                  <div class="col-12">
                    <i class="fa fa-times-circle text-red pr-2" />
                    <span class="invalid">
                      {{ field.checkboxConditions.errorMsg }}
                    </span>
                  </div>
                </div>
              </div>
            </ValidationProvider>
          </div>
        </div>
      </div>

      <div
        v-if="isPendingSignatureMode"
        v-show="activeTab === 1"
        class="row mx-3 mt-4"
      >
        <div class="col-12">
          <SectionTitle content="Documento" />
          <div class="dropdown-divider w-100 my-0" />
          <div class="row align-items-center signed-referral-panel mt-3">
            <div class="col-md-6 col-sm-12">
              <span class="signed-referral-label">Documento:</span>
              <span class="d-block">Hoja de Referido Firmada</span>
            </div>
            <div class="col-md-4 col-sm-12">
              <span class="signed-referral-label">Archivo:</span>
              <ActionButton
                v-if="!hasDownloadedReferral"
                type="button"
                variant="outline-success w-100"
                i="fas fa-file-download"
                :disabled="isDownloadingReferral"
                @click="downloadReferralReport"
              >
                Descargar Hoja de Referido Firmada
              </ActionButton>
              <ValidationProvider v-else v-slot="{ errors }" rules="required">
                <CustomFileInput
                  :key="signedReferralInputKey"
                  v-model="signedReferralDocument"
                  :accept="'.pdf'"
                  :max-size="1"
                  can-delete
                  display-style="normal"
                  label-position="left"
                  :error="errors[0]"
                  custom-error-msg="Favor de anejar el documento de referido firmado."
                  @delete="removeSignedReferralDocument"
                />
              </ValidationProvider>
            </div>
          </div>
        </div>
      </div>
    </ValidationObserver>
    <custom-contact-info-modal
      ref="contactInfoModalRef"
      @cancel="cancelContactInfoModal"
      @save="saveContactInfoModal"
    />
  </div>
</template>

<script>
import store from '@/store/index';
import loading from '@/mixin/loading.mixin';
import alert from '@/mixin/alert.mixin';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import Breadcrumb from '@/components/common/page/TitleBreadcrumb';
import WarningBox from '@/components/pei/service/components/ServiceWarningBox';
import disciplineCategories from '@/utils/constants/student/disciplineCategories';
import { SectionTitle } from '@/components/pei/shared';
import {
  CustomDatePicker,
  ActionButton,
  CustomDropDown,
  CustomTextArea,
  CustomFileInput,
} from '@/components/common';
import CustomContactInfoModal from '@/components/common/CustomContactInfoModal';
import StudentMedicalInfo from '@/views/student/AdditionalEvaluations/components/StudentMedicalInfo.vue';
import StudentInterventionLevel from '@/views/student/AdditionalEvaluations/components/StudentInterventionLevel.vue';
import ABADocumentation from './components/ABADocumentation.vue';
import disciplines from '@/utils/constants/disciplineTypes.js';
import CustomCheckboxSingleOption from 'custom-checkbox-single-option';
import appointmentServiceManager from '@/services/api/appointment.api.js';
import objectToFormData from 'object-to-formdata';
import StudentAlternatePlacement from '@/views/student/AdditionalEvaluations/components/StudentAlternatePlacement.vue';
import DocumentsForm from '@/views/humanResources/request/components/DocumentsForm';
import documentTypes from '@/utils/constants/documentTypes';
import alternatePlacementsTypes from '@/utils/constants/alternatePlacements';
import categoryAlternativePlacement from '@/utils/constants/categoryAlternativePlacement';
import DocumentsService from '@/services/report';
import { getSysparameterByNames } from '@/modules/system-parameter-managment/api';
import compuMinuteService from '@/modules/compu-minutes-editor/api';
const Saee03Id = 1192;
const Saee04Id = 1546;
const signedReferralMaxFileSizeInBytes = 10 * 1024 * 1024;
const pendingSignatureStatusId = 15;
export default {
  mixins: [loading, alert],
  components: {
    Breadcrumb,
    ActionButton,
    CustomTextArea,
    ValidationObserver,
    CustomDropDown,
    CustomDatePicker,
    CustomFileInput,
    WarningBox,
    ValidationProvider,
    SectionTitle,
    CustomContactInfoModal,
    StudentMedicalInfo,
    CustomCheckboxSingleOption,
    StudentInterventionLevel,
    StudentAlternatePlacement,
    ABADocumentation,
    DocumentsForm,
  },
  data() {
    return {
      disciplines,
      documentTypes,
      name: 'AddEditEvaluations',
      page: {
        icon: 'fas fa-user-edit',
        title: 'Añadir Referido a Evaluación',
        routes: [
          'Inicio',
          'Estudiante',
          'Solicitud de Evaluación Adicional/Añadir Referido a Evaluación',
        ],
      },
      studentSie: store.getters['$_student/StudentSie'],
      ValidationTriggered: store.getters.getatValidationTriggered,
      apiUrl: '/api/studentEvaluation',
      field: {
        datePickerDateEvaluation: {
          isRequired: true,
          disabled: false,
          label: 'Fecha',
          maxDate: new Date(),
          errorMsg: 'Favor de seleccionar una fecha para la solicitud.',
          selected: new Date(),
        },
        dropDownEvaluation: {
          isRequired: true,
          disabled: false,
          label: 'Evaluación',
          id: 'dropDownEvaluation',
          placeHolder: 'Seleccione',
          fieldkey: 'evaluationTypeId',
          fieldname: 'description',
          errorMsg: 'Favor de seleccionar un tipo de evaluación.',
          items: [],
          selected: null,
        },
        dropDownDiscipline: {
          isRequired: true,
          disabled: true,
          label: 'Disciplina',
          id: 'dropDownDiscipline',
          placeHolder: 'Seleccione',
          fieldkey: 'id',
          fieldname: 'disciplineName',
          errorMsg: 'Favor de seleccionar una disciplina.',
          items: [],
          selected: null,
        },
        textAreaReason: {
          isRequired: true,
          disabled: false,
          isVisible: true,
          maxlength: 3000,
          rows: 5,
          placeHolder: 'Razón de referido',
          errorMsg:
            'Favor de escribir una razón para solicitar esta evaluación.',
          model: null,
        },
        checkboxConditions: {
          isRequired: true,
          disabled: false,
          selected: null,
          errorMsg:
            'Debe aceptar los términos y responsabilidades para poder continuar. (0229)',
        },
        btnSave: {
          isEnabled: true,
          text: 'Guardar',
        },
        btnReturn: {
          text: 'Regresar',
        },
        medicalInformation: {
          disabled: false,
        },
        interventionLevel: {
          disabled: false,
        },
        alternatePlacement: {
          disabled: false,
        },
      },
      medicalInfo: {
        healthCondition: null,
        surgicalIntervention: null,
        surgicalInterventionDate: null,
        medicationSchoolHours: null,
        explainMedication: null,
        allergy: null,
        equipments: [],
      },
      interventionLevelInfo: {},
      alternatePlacementInfo: {
        alternatePlacement: {},
        documents: [],
      },
      documentErrors: [],
      abaDocuments: [],
      selectedDiscipline: null,
      additionalDocuments: [],
      savedDocuments: [],
      createdReferralId: 0,
      referralStatusId: null,
      isReferralSaved: false,
      sysParameters: [],
      additionalDocumentTypes: [
        {
          id: documentTypes.SAEE_Minute,
          name: 'Minuta SAEE-08',
        },
      ],
      minuteInfo: {
        useSystemMinute: null,
        compuMinuteId: null,
        fileId: null,
        fileName: null,
      },
      activeTab: 0,
      signedReferralDocument: null,
      signedReferralInputKey: 0,
      hasDownloadedReferral: false,
      isDownloadingReferral: false,
      isSubmittingSignedReferral: false,
    };
  },
  computed: {
    selectedDisciplineId() {
      return this.selectedDiscipline?.id ?? null;
    },
    isAdaptedPhysicalEducationSelected() {
      return this.selectedDisciplineId == disciplines.FisicaAdaptada;
    },
    isABASelected() {
      return this.selectedDisciplineId == disciplines.ABA;
    },
    isUserPilotPlan() {
      return store.getters['$_user/pilotPlan'];
    },
    isVocationalEducationSelected() {
      return (
        this.selectedDisciplineId == disciplines.EducacionVocacional ||
        this.selectedDisciplineId ==
          disciplines.EvaluacionVocacionalPreliminar ||
        this.selectedDisciplineId == disciplines.EvaluacionVocacionalFinal
      );
    },
    isEFASelected() {
      return this.selectedDisciplineId == disciplines.FisicaAdaptada;
    },
    studentReferralId() {
      return (
        Number(this.$route.query.studentReferralId) || this.createdReferralId
      );
    },
    isExistingReferral() {
      return this.studentReferralId > 0 || this.isReferralSaved;
    },
    isPendingSignatureMode() {
      return (
        this.isExistingReferral &&
        this.referralStatusId === pendingSignatureStatusId
      );
    },
    isCompuMinuteSystemSelectionEnabled() {
      let obj = this.sysParameters.find(
        (item) => item.name === 'ActiveCompuMinuteSystemSelection'
      );
      return obj?.staticValue?.toLowerCase() === 'true' ?? false;
    },
    hasMinuteAttached() {
      return (
        this.additionalDocuments.some(
          (document) => document.documentTypeId === documentTypes.SAEE_Minute
        ) || this.minuteInfo.useSystemMinute === true
      );
    },
    isPendingSignatureFlowEnabled() {
      const parameter = this.sysParameters.find(
        (item) =>
          item.name ===
          'AdditionalEvaluationReferralPendingSignatureFlowEnabled'
      );
      return (
        String(parameter?.staticValue)
          .trim()
          .toLowerCase() === 'true'
      );
    },
  },
  methods: {
    validateEFA04() {
      let emptyError = '';
      let saee04Message = 'El documento de SAEE (EFA-04) es requerido.';
      let saee03Message = 'El documento de SAEE (EFA-03) es requerido.';
      const isRequiredEFA04 = this.isEFASelected;

      if (!isRequiredEFA04) return emptyError;

      const isValid =
        this.alternatePlacementInfo.documents.filter(
          (doc) => doc.documentTypeId == documentTypes.SAEE_EFA4
        ).length > 0;

      const requiredSae04 = [
        categoryAlternativePlacement.SalonRecurso,
        categoryAlternativePlacement.SalonEspecialSEM,
        categoryAlternativePlacement.Hogar,
        categoryAlternativePlacement.Itinerante,
      ].includes(this.alternatePlacementInfo.categoryAlternativePlacement.id);

      const conteinSae04 = this.alternatePlacementInfo.documents.some(
        (doc) => doc.documentTypeId === Saee04Id
      );
      const conteinSae03 = this.alternatePlacementInfo.documents.some(
        (doc) => doc.documentTypeId === Saee03Id
      );

      if (requiredSae04 && conteinSae04) {
        return emptyError;
      }

      if (!requiredSae04 && conteinSae03) {
        return emptyError;
      }

      if (requiredSae04 && !conteinSae04) {
        return saee04Message;
      }

      if (!requiredSae04 && !conteinSae03) {
        return saee03Message;
      }
    },
    validateEFA03() {
      let emptyError = '';
      const isRequiredEFA03 =
        this.isEFASelected &&
        [
          alternatePlacementsTypes.SalonEspecialEnEscuelaRegular,
          alternatePlacementsTypes.SalonRegularConServiciosDeSalonRecurso,
          alternatePlacementsTypes.SalonRegularConServiciosRelacionados,
          alternatePlacementsTypes.SalonRegularConServiciosYAyudaSuplementaria,
          alternatePlacementsTypes.SalonRegularConServiciosSuplementarios,
        ].includes(this.alternatePlacementInfo.alternatePlacement?.id);

      if (!isRequiredEFA03) return emptyError;

      const isValid =
        this.alternatePlacementInfo.documents.filter(
          (doc) => doc.documentTypeId == documentTypes.SAEE_EFA3
        ).length > 0;

      if (isValid) return emptyError;

      return 'El documento de SAEE (EFA-03) es requerido.';
    },
    validateDocuments() {
      this.documentErrors = [];
      const errorMessageEFA03 = this.validateEFA03();
      const errorMessageEFA04 = this.validateEFA04();

      if (!!errorMessageEFA03) this.documentErrors.push(errorMessageEFA03);
      if (!!errorMessageEFA04) this.documentErrors.push(errorMessageEFA04);

      return this.documentErrors.length == 0;
    },
    disableFields(disable = true) {
      this.field.datePickerDateEvaluation.disabled = disable;
      this.field.dropDownEvaluation.disabled = disable;
      this.field.dropDownDiscipline.disabled = disable;
      this.field.textAreaReason.disabled = disable;
      this.field.checkboxConditions.disabled = disable;
      this.field.btnSave.isEnabled = !disable;
      if (this.isAdaptedPhysicalEducationSelected) {
        this.field.medicalInformation.disabled = disable;
      }
    },
    checkboxConditionsChange() {
      if (!this.field.checkboxConditions.selected) {
        this.field.checkboxConditions.selected = null;
      }
    },
    async getEvaluations() {
      return this.$ApiGet(`${this.apiUrl}/EvaluationTypes/${true}`).then(
        (res) =>
          (this.field.dropDownEvaluation.items = res.data ? res.data : [])
      );
    },
    async getDisciplines() {
      this.field.dropDownDiscipline.selected = null;
      this.selectedDiscipline = null;
      this.resetDisciplineDocuments();

      if (this.field.dropDownEvaluation.selected) {
        const response = await this.$ApiGet(
          `${this.apiUrl}/${this.studentSie}/validDisciplineTypes/${this.field.dropDownEvaluation.selected.evaluationTypeId}/${disciplineCategories.ValidForAppointment}`
        );
        this.field.dropDownDiscipline.items = response.data
          ? response.data
          : [];
        this.field.dropDownDiscipline.disabled = false;
      } else {
        this.field.dropDownDiscipline.disabled = true;
        this.field.dropDownDiscipline.items = [];
      }
    },
    async validateSelectedMinute() {
      if (!this.isCompuMinuteSystemSelectionEnabled) return true;

      if (this.isEFASelected) {
        return (
          (await this.$refs.alternatePlacementRef?.validateMinute?.()) ?? true
        );
      }

      if (this.isABASelected) {
        return (
          (await this.$refs.abaDocumentationRef?.validateMinute?.()) ?? true
        );
      }

      if (this.isVocationalEducationSelected) {
        return (
          (await this.$refs.interventionLevelRef?.validateMinute?.()) ?? true
        );
      }

      return this.hasMinuteAttached;
    },
    async handleSubmit() {
      if (this.isExistingReferral) return;
      if (!this.field.btnSave.isEnabled) return;

      const isValid = await this.$refs.formObserver.validate();
      const areValidDocuments = this.validateDocuments();
      const isMinuteValid = await this.validateSelectedMinute();

      if (!isMinuteValid) {
        this.ShowToast(
          'Información Incompleta',
          'Debe seleccionar o adjuntar la Minuta de COMPU antes de guardar el referido.',
          'error'
        );

        return;
      }

      if (!isValid || !areValidDocuments) {
        this.ShowToast(
          'Información Incompleta',
          'Favor de completar la información requerida.',
          'error'
        );

        return;
      }

      if (
        this.isAdaptedPhysicalEducationSelected &&
        !this.medicalInfo.equipments.length
      ) {
        this.ShowToast(
          'Información Incompleta',
          'Favor seleccione al menos un equipo.',
          'error'
        );
        return;
      }

      await this.$refs.contactInfoModalRef.open();
    },
    async saveContactInfoModal(contactInfoParams) {
      if (this.isExistingReferral || !this.field.btnSave.isEnabled) return;
      let self = this;
      const disciplineId = self.selectedDisciplineId;
      let params = {
        ...this.medicalInfo,
        equipments: this.medicalInfo.equipments.map((e) => {
          return {
            Id: e.id,
            otherDescription: e.otherDescription,
          };
        }),
        studentsieid: parseInt(self.studentSie),
        evaluationdate: self.field.datePickerDateEvaluation.selected,
        evaluationtypeid:
          self.field.dropDownEvaluation.selected.evaluationTypeId,
        disciplineid: disciplineId,
        referralrequestreason: self.field.textAreaReason.model,
        studentcontactinformation: contactInfoParams,
        issystemminute: this.isCompuMinuteSystemSelectionEnabled
          ? this.minuteInfo.useSystemMinute
          : null,
        compuminuteid: this.isCompuMinuteSystemSelectionEnabled
          ? this.minuteInfo.compuMinuteId
          : null,
      };

      this.disableFields();

      if (this.isVocationalEducationSelected) {
        params = {
          ...params,
          interventionLevelVocationalEvaluation: {
            phaseId: this.interventionLevelInfo.phase.id,
            schoolContactName: this.interventionLevelInfo.schoolContactName,
            schoolPositionId: this.interventionLevelInfo.schoolContactPosition
              .signaturePositionId,
            schoolPhone: this.interventionLevelInfo.schoolContactPhone,
            schoolEmail: this.interventionLevelInfo.schoolContactEmail,
          },
        };
      }

      if (this.isEFASelected) {
        params = {
          ...params,
          categoryAlternativePlacementId: this.alternatePlacementInfo
            .categoryAlternativePlacement.id,
          alternativePlacementId: this.alternatePlacementInfo
            .alternativePlacement.id,
          primaryLanguageId: this.alternatePlacementInfo.primaryLanguage.id,
          otherPrimaryLanguage: this.alternatePlacementInfo
            .otherPrimaryLanguage,
        };
      }

      let formData = objectToFormData(params, { indices: true });

      if (this.isVocationalEducationSelected) {
        formData.append(
          'interventionLevelVocationalEvaluationFile',
          this.interventionLevelInfo.document
        );
      }

      if (this.isEFASelected) {
        if (this.alternatePlacementInfo.documents.length > 0) {
          this.alternatePlacementInfo.documents.forEach((element) => {
            switch (element.documentTypeId) {
              case documentTypes.SAEE_EFA3:
                formData.append('SAEE_EFA3', element.file);
                break;
              case documentTypes.SAEE_EFA4:
                formData.append('SAEE_EFA4', element.file);
                break;
              case documentTypes.SAEE_Minute:
                formData.append('SAEE_Minute', element.file);
                break;
              case documentTypes.OtherDocuments:
                formData.append('OtherDocuments', element.file);
                break;
              default:
                break;
            }
          });
        }
      }

      if (this.isABASelected && this.abaDocuments.length > 0) {
        this.abaDocuments.forEach((x) => {
          switch (x.documentTypeId) {
            case documentTypes.SAEE_14:
              formData.append('SAEE_14', x.file);
              break;
            case documentTypes.SAEE_FBA_01:
              formData.append('SAEE_FBA_01', x.file);
              break;
            case documentTypes.SAEE_FBA_02:
              formData.append('SAEE_FBA_02', x.file);
              break;
            default:
              break;
          }
        });
      }

      this.additionalDocuments.forEach((document) => {
        formData.append('SAEEMinuteDocuments', document.file);
      });

      return self
        .$ApiPost('/api/student/CreateStudentReferral', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(async ({ data }) => {
          this.isReferralSaved = true;
          this.ShowToast(
            'Verificar información de contacto',
            'Guardado Exitosamente!',
            'success'
          );

          if (this.isPendingSignatureFlowEnabled) {
            await this.openSavedReferral(data);
            return;
          }

          if (this.isUserPilotPlan) {
            const {
              data: isExcluded,
            } = await appointmentServiceManager.isDisciplineExcludedForPilotPlan(
              disciplineId
            );
            if (!isExcluded) {
              await this.$router.push({ name: 'evaluations-appointment' });
              return;
            }
          }

          await this.$router.push({ path: '/student' });
        })
        .catch((err) => {
          // enable all fields again if an exception occurs
          if (!this.isReferralSaved) this.disableFields(false);
          const errorMsg =
            err.response?.data?.message ||
            err.data?.message ||
            'No fue posible completar la operación.';
          this.ShowToast('Error', errorMsg, 'error');
        });
    },
    cancelContactInfoModal() {},
    async openSavedReferral(data) {
      this.createdReferralId = Number(data?.studentReferralId) || 0;
      if (!this.createdReferralId) {
        this.ShowToast(
          'Error',
          'La solicitud fue guardada, pero no fue posible obtener su identificador.',
          'error'
        );
        return;
      }

      this.activeTab = 0;
      await this.$router.replace({
        name: 'AddEditEvaluations',
        query: { studentReferralId: this.createdReferralId },
      });
      const loaded = await this.loadReferral();
      if (loaded && this.isPendingSignatureMode) {
        this.activeTab = 1;
      }
    },
    async loadReferral() {
      this.disableFields();
      try {
        const { data } = await this.$ApiGet(
          `${this.apiUrl}/referral/${this.studentReferralId}`
        );

        this.field.datePickerDateEvaluation.selected = data.requestDate
          ? new Date(data.requestDate)
          : null;
        this.field.dropDownEvaluation.selected = this.field.dropDownEvaluation.items.find(
          (item) => item.evaluationTypeId === data.evaluationTypeId
        ) || {
          evaluationTypeId: data.evaluationTypeId,
          description: data.evaluationType,
        };

        await this.getDisciplines();
        this.field.dropDownDiscipline.selected = this.field.dropDownDiscipline.items.find(
          (item) => item.id === data.disciplineTypeId
        ) || {
          id: data.disciplineTypeId,
          disciplineName: data.discipline,
        };
        this.selectedDiscipline = this.field.dropDownDiscipline.selected;
        this.field.textAreaReason.model = data.referralRequestReason;
        this.savedDocuments = data.documents || [];
        this.referralStatusId = data.referralStatusId;
        this.field.checkboxConditions.selected = true;
        this.disableFields();
        return true;
      } catch (err) {
        const errorMsg =
          err.response?.data?.message ||
          err.data?.message ||
          'No fue posible cargar el referido a evaluación.';
        this.ShowToast('Error', errorMsg, 'error');
        return false;
      }
    },
    async downloadReferralReport() {
      this.isDownloadingReferral = true;
      try {
        await DocumentsService.downloadReferralReport(this.studentReferralId);
        this.hasDownloadedReferral = true;
      } catch (err) {
        const errorMsg =
          err.response?.data?.message ||
          err.data?.message ||
          'No fue posible descargar la hoja de referido.';
        this.ShowToast('Error', errorMsg, 'error');
      } finally {
        this.isDownloadingReferral = false;
      }
    },
    async submitPendingSignatureReferral() {
      if (!this.isPendingSignatureMode) return;
      if (!this.signedReferralDocument) {
        this.ShowToast(
          'Información Incompleta',
          'Favor de anejar el documento de referido firmado.',
          'error'
        );
        return;
      }

      if (this.signedReferralDocument.size > signedReferralMaxFileSizeInBytes) {
        this.ShowToast(
          'Archivo Inválido',
          'El documento no puede tener un tamaño mayor a 10 MB.',
          'error'
        );
        return;
      }

      const formData = new FormData();
      formData.append('document', this.signedReferralDocument);
      this.isSubmittingSignedReferral = true;

      try {
        await this.$ApiPost(
          `${this.apiUrl}/submit-pending-signature-referral/${this.studentReferralId}`,
          formData,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        );
        this.ShowToast(
          'Proceso Exitoso.',
          'El documento ha sido cargado exitosamente.',
          'success'
        );
        this.$router.push({ name: 'Additional' });
      } catch (err) {
        const errorMsg =
          err.response?.data?.message ||
          err.data?.message ||
          'No fue posible cargar el documento firmado.';
        this.ShowToast('Error', errorMsg, 'error');
      } finally {
        this.isSubmittingSignedReferral = false;
      }
    },
    removeSignedReferralDocument() {
      this.signedReferralDocument = null;
      this.signedReferralInputKey += 1;
    },
    resetDisciplineDocuments() {
      this.additionalDocuments = [];
      this.abaDocuments = [];
      this.alternatePlacementInfo.documents = [];
      this.documentErrors = [];
      this.minuteInfo = {
        useSystemMinute: null,
        compuMinuteId: null,
        fileId: null,
        fileName: null,
      };
    },
    onChangeDiscipline(discipline) {
      if (typeof discipline === 'string') return;

      const previousDisciplineId = this.selectedDisciplineId;
      this.selectedDiscipline = discipline || null;

      if (previousDisciplineId !== this.selectedDisciplineId) {
        this.resetDisciplineDocuments();
      }

      this.interventionLevelInfo = {};
    },
    async fetchParams() {
      const { data: sysParameters } = await getSysparameterByNames({
        parameterNames: [
          'ActiveCompuMinuteSystemSelection',
          'AdditionalEvaluationReferralPendingSignatureFlowEnabled',
        ],
      });

      this.sysParameters = sysParameters;
    },
    async goToDraftMinute() {
      if (!this.field.datePickerDateEvaluation.selected) {
        this.ShowToast(
          'Alerta',
          'La fecha de la solicitud es requerida para redactar la minuta.',
          'error'
        );
        return;
      }

      const response = await compuMinuteService
        .getOrCreateDraftFromEvaluationDiscussion({
          studentSieId: Number(this.studentSie),
          date: this.field.datePickerDateEvaluation.selected,
        })
        .catch((err) => {
          this.ShowToast(
            'Error',
            err?.response?.data?.message ||
              'No fue posible crear la minuta de COMPU.',
            'error'
          );
        });

      const id = response?.data?.id ?? response?.data;
      if (!id) return;

      this.$router.push(`/pei/compu-minutes-editor/${id}`);
    },
    
  },
  watch: {
    'alternatePlacementInfo.documents'() {
      this.documentErrors = [];
    },
  },
  async mounted() {
    await this.getEvaluations();
    await this.fetchParams();
    if (this.isExistingReferral) {
      await this.loadReferral();
    }
  },
};
</script>

<style scope>
form {
  width: 100%;
}
</style>
<style src="@/assets/css/component/radio-button.css"></style>
<style src="@/assets/css/component/datepicker.css"></style>
<style src="@/assets/css/component/badge.css"></style>
<style src="@/assets/css/component/textarea.css"></style>
<style src="@/assets/css/component/messages.css"></style>

<style scoped>
.disabled-page {
  pointer-events: none;
}

.wrapper-block {
  cursor: not-allowed !important;
}
.global-thead-dark {
  background-color: #3f5b60 !important;
}
.buttoneval {
  border: 1px solid #2db782;
  color: #2db782;
}
.pending-signature-tabs {
  border-bottom: 1px solid #e2e2e2;
}

.pending-signature-tabs button {
  min-width: 190px;
  padding: 12px 24px;
  color: #727272;
  background: transparent;
  border: 0;
  border-bottom: 3px solid transparent;
}

.pending-signature-tabs button.active {
  color: #ff7058;
  font-weight: bold;
  border-bottom-color: #ff7058;
}

.signed-referral-panel {
  padding: 20px;
  background-color: #f7f7f7;
  border-radius: 5px;
}

.signed-referral-label {
  display: block;
  color: #727272;
  font-size: 14px;
}
.tag-badge {
  display: inline-block;
  padding-right: 1em;
  height: 42px;
  background: transparent linear-gradient(90deg, #ffffff 0%, #e8e8e8 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 26px;
  cursor: pointer;
  margin-bottom: 10px;
}

.dot {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: inline-block;
  /* top: 268px; */
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  padding-top: 9px;
}
.orange-icon {
  color: #ff7058;
}

.orange-icon-badge-align {
  vertical-align: top;
}

.tag-badge-title {
  text-align: left;
  font: Bold 25px/30px Lato;
  letter-spacing: 0;
  color: #11291b;
  display: inline-block;
}
.item-pane {
  justify-content: space-between;
  min-width: 50%;
  box-shadow: -3px 1px 3px #00000029;
  margin-top: 10px;
  display: flex;
  border-bottom: solid 1px #e2e2e2;
}

.item-pane-info {
  background: #f2f2f2 0% 0% no-repeat padding-box;
  border-radius: 0px 0px 5px 5px;
  margin-bottom: 10px;
  font: 400 14px/17px Lato;
  letter-spacing: 0;
  color: #11291b;
  padding: 20px 10px 10px;
}

.item-pane-info p {
  margin-bottom: 10px;
}

.item-pane-info p i {
  margin-right: 8px;
  font-size: 16px;
}
.question-box {
  width: 65px;

  border-radius: 5px 5px 0px 0px;
  text-align: center;
  color: #ffffff;
  letter-spacing: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  /* padding: 22px 12px; */
}
.border-box {
  border: 1px solid #e2e2e2;
  border-radius: 5px 5px 0px 0px;
  padding: 20px;
  width: 100%;
}
.border-box.gray {
  border-radius: 0px 0px 5px 0px;
  background: #f2f2f2 0% 0% no-repeat padding-box;
  border-top: none;
  padding: 20px 0;
}
.border-box.gray.error {
  background: #ffebeb 0% 0% no-repeat padding-box;
  border: 1px solid #c9545e;
}
.invalid {
  text-align: left;
  font: Lato, Regular;
  letter-spacing: 0;
  color: #ff5b5c;
  margin-bottom: 5px;
  font-weight: normal;
}
i.far.fa-check-circle {
  font-size: 24px;
  padding-right: 4px;
  line-height: 18px;
  margin-left: 4px;
}
</style>
